import getEsriData from "context/contextFunctions/getEsriData";
/* eslint-disable */
// eslint-disable-next-line consistent-return
export default async function getHods({
  layerId,
  dispatch,
  hods,
  token,
  query = "1=1",
}) {
  if (!hods && layerId !== undefined) {
    const { res } = await getEsriData({
      token,
      layerId,
      layer: process.env.REACT_APP_DLS_Lockups_Table,
      outFields: "HOD_ANAME,HOD_CODE,VILL_CODE",
      returnDistinctValues: true,
      featureOrMap: "MapServer",
      returnGeometry: false,
      query,
    });
    if (dispatch) dispatch({ type: "INIT", payload: { hods: res } });
    return res;
  }
}
